// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nlp-designer {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.nlp-designer__header {
    padding: 15px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    
}

.nlp-designer__header-select {
    display: block !important;
    height: 3.6rem !important;
    min-height: 3.6rem !important;
    width: auto !important;
    padding: 0px !important;
    margin: 0 !important;
    border-radius: 2px !important;
    border: none !important;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14),
        0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2) !important;
    color: #fff !important;
    background-color: #26a69a !important;
    font-size: 14px !important;
    text-align: center !important;
    text-decoration: none !important;
    letter-spacing: 0.5px !important;
    white-space: nowrap !important;
    transition: background-color 0.2s ease-out !important;
    cursor: pointer !important;
}

.nlp-designer__header-select div,
.nlp-designer__header-select input {
    height: 3.6rem !important;
    min-height: 3.6rem !important;
    width: auto !important;
    min-width: auto !important;
    padding: 10px 32px 10px 10px !important;
    margin: 0 !important;
}

.nlp-designer__header-select svg {
    fill: white !important;
    stroke: white !important;
}

.nlp-designer__header-select-item li {
    font-size: 14px !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/nlpDesigner/NLPDesigner.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;;AAEb;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,6BAA6B;IAC7B,sBAAsB;IACtB,uBAAuB;IACvB,oBAAoB;IACpB,6BAA6B;IAC7B,uBAAuB;IACvB;qFACiF;IACjF,sBAAsB;IACtB,oCAAoC;IACpC,0BAA0B;IAC1B,6BAA6B;IAC7B,gCAAgC;IAChC,gCAAgC;IAChC,8BAA8B;IAC9B,qDAAqD;IACrD,0BAA0B;AAC9B;;AAEA;;IAEI,yBAAyB;IACzB,6BAA6B;IAC7B,sBAAsB;IACtB,0BAA0B;IAC1B,uCAAuC;IACvC,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;IACtB,wBAAwB;AAC5B;;AAEA;IACI,0BAA0B;AAC9B","sourcesContent":[".nlp-designer {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n}\r\n\r\n.nlp-designer__header {\r\n    padding: 15px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 20px;\r\n    \r\n}\r\n\r\n.nlp-designer__header-select {\r\n    display: block !important;\r\n    height: 3.6rem !important;\r\n    min-height: 3.6rem !important;\r\n    width: auto !important;\r\n    padding: 0px !important;\r\n    margin: 0 !important;\r\n    border-radius: 2px !important;\r\n    border: none !important;\r\n    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14),\r\n        0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2) !important;\r\n    color: #fff !important;\r\n    background-color: #26a69a !important;\r\n    font-size: 14px !important;\r\n    text-align: center !important;\r\n    text-decoration: none !important;\r\n    letter-spacing: 0.5px !important;\r\n    white-space: nowrap !important;\r\n    transition: background-color 0.2s ease-out !important;\r\n    cursor: pointer !important;\r\n}\r\n\r\n.nlp-designer__header-select div,\r\n.nlp-designer__header-select input {\r\n    height: 3.6rem !important;\r\n    min-height: 3.6rem !important;\r\n    width: auto !important;\r\n    min-width: auto !important;\r\n    padding: 10px 32px 10px 10px !important;\r\n    margin: 0 !important;\r\n}\r\n\r\n.nlp-designer__header-select svg {\r\n    fill: white !important;\r\n    stroke: white !important;\r\n}\r\n\r\n.nlp-designer__header-select-item li {\r\n    font-size: 14px !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
